import { Outlet } from "react-router-dom";
import { useGlobalState } from "../components/global";
import { useEffect } from "react";
import SideMenu from "../components/side_menu";

export default function PulseDiagnosis() {
    const { navActive } = useGlobalState();

    useEffect(() => {
        navActive("/pulse-diagnosis");
    }, []);

    return <div className="module module-pulse-diagnosis" style={{ display: 'grid', gridTemplateColumns: '260px 1fr' }}>
        <div className="side-menu">
            <SideMenu />
        </div>
        <div className="content" style={{ overflowY: "auto", overflowX: "hidden" }}>
            <Outlet />
        </div>
    </div>

};